export var Direction;
(function (Direction) {
    Direction[Direction["UP"] = 1] = "UP";
    Direction[Direction["DOWN"] = -1] = "DOWN";
})(Direction || (Direction = {}));
//# sourceMappingURL=interface.js.map
